import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then(r => setLogs(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Audit</div><h1 className="cm-h2">Recent actions</h1></div>
      <div className="cm-card divide-y divide-[#e2e8f0]" data-testid="audit-list">
        {logs.map(l => (
          <div key={l.id} className="py-3 first:pt-0 last:pb-0 text-sm flex items-center justify-between">
            <div>
              <div className="text-[#1a2b4a] font-medium">{l.action}</div>
              <div className="text-xs text-[#475569]">Target: {l.target || "—"} · Status: {l.status || "—"}</div>
              {l.note && <div className="text-xs text-[#94a3b8] mt-0.5 italic">"{l.note}"</div>}
            </div>
            <div className="text-xs text-[#94a3b8]">{(l.created_at||"").slice(0,16).replace("T"," ")}</div>
          </div>
        ))}
        {logs.length === 0 && <div className="py-3 text-sm text-[#475569]">No audit entries.</div>}
      </div>
    </div>
  );
}
